// registerServiceWorker.ts
import { getRunningSiteBaseUrl } from "@webcore/config/appConfig.ts";

export default function registerServiceWorker() {
  // Skip registration in development mode
  if (import.meta.env.MODE === 'dev') {
    console.log('Service worker registration skipped in development mode');
    return;
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const baseUrl: string = getRunningSiteBaseUrl();

      const swUrl = `${baseUrl}/service-worker.js`;
      console.log(`Registering service worker with URL: ${swUrl}`);

      // // Configure the registration options
      // const options = {
      //   // Scope is default, but can be explicitly set if needed
      //   scope: '/'
      // };

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration.scope);

          // Check if there's a waiting worker on initial registration
          if (registration.waiting) {
            console.log('New version waiting on initial registration');
            notifyUserOfUpdate(registration.waiting);
          }

          // Listen for new service worker installation
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            console.log('New service worker update found, installing...');

            // Track state changes of the installing worker
            newWorker.addEventListener('statechange', () => {
              console.log(`Service Worker state changed: ${newWorker.state}`);

              // When the new service worker is installed (waiting), notify user
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New version installed and waiting to activate');
                notifyUserOfUpdate(newWorker);
              }
            });
          });

          // Check for updates every 30 minutes
          // This is useful for users who keep the app open for long periods
          setInterval(() => {
            console.log('Checking for service worker updates...');
            registration.update();
          }, 30 * 60 * 1000);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });

      // Listen for messages from the service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('Message received from service worker:', event.data);

        if (event.data && event.data.type === 'NEW_VERSION_AVAILABLE') {
          console.log(`New app version available: ${event.data.version}`);
          // Reload the app when a new version is available
          reloadApplication();
        }
      });
    });
  }
}

// Function to notify user about update and handle reload
function notifyUserOfUpdate(worker) {
  // You can implement a UI notification here
  console.log('New version available! Reloading app...');

  // Skip waiting and reload
  worker.postMessage({ type: 'SKIP_WAITING' });

  // Delay slightly to give the worker time to activate
  setTimeout(() => {
    reloadApplication();
  }, 300);
}

// Function to reload the application properly
function reloadApplication() {
  // Clear any session storage that shouldn't persist across updates
  // sessionStorage.clear(); // Uncomment if needed

  // Force a hard reload to ensure new assets are loaded
  window.location.reload();
}
